module.exports = __webpack_public_path__ + "img/list_filled_64.da893bf1.svg";